export default __webpack_public_path__ + "static/media/ic_yemen.7a5a93ac.svg";